import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IAPIState } from "shared/types";
import { DeleteInfoBlockItemModal as Component } from "shared/components";
import { DeleteInfoBlockItemBaseProps, useDeleteInfoBlockItem } from "shared/utils";
import { useBandContext } from "Bands/contexts";
import { BAND_ACTIONS } from "Bands/types";
import { clearActionPagination, dataMetaSelector, deleteInfoBlockItem } from "Bands/state";
import { getInfoBlockItemKey, useClearActionMetaOnUnMount } from "Bands/utils";

export const DeleteInfoBlockItemModal: FC<DeleteInfoBlockItemBaseProps> = ({
  deleteItem,
  handleClose,
  type,
}) => {
  const { bandId } = useBandContext();
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.deleteInfoBlockItem));
  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteInfoBlockItem);

  const handleDelete = () => {
    dispatch(
      deleteInfoBlockItem({
        id: deleteItem.id,
        type,
      })
    );
  };

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      bandId && dispatch(clearActionPagination(getInfoBlockItemKey(bandId, type)));
    }
  }, [apiMeta, dispatch, bandId, type]);

  const { itemReadbleName, extraDeleteMessage } = useDeleteInfoBlockItem({
    type,
    handleClose,
    deleteItemApiStatus: apiMeta?.status,
  });

  return (
    <Component
      type={type}
      deleteItem={deleteItem}
      itemReadbleName={itemReadbleName}
      handleClose={handleClose}
      handleDelete={handleDelete}
      deleteItemApiStatus={apiMeta?.status}
      deleteItemApiError={apiMeta?.error}
      extraDeleteMessage={extraDeleteMessage}
    />
  );
};
